<template>
  <g>
    <g clip-path="url(#clip0_15_606)">
      <path
        d="M20 4.00016H16L12.71 0.710164C12.32 0.320164 11.69 0.320164 11.3 0.710164L8 4.00016H4C2.9 4.00016 2 4.90016 2 6.00016V20.0002C2 21.1002 2.9 22.0002 4 22.0002H20C21.1 22.0002 22 21.1002 22 20.0002V6.00016C22 4.90016 21.1 4.00016 20 4.00016ZM19 20.0002H5C4.45 20.0002 4 19.5502 4 19.0002V7.00016C4 6.45016 4.45 6.00016 5 6.00016H8.52L12.04 2.50016L15.52 6.00016H19C19.55 6.00016 20 6.45016 20 7.00016V19.0002C20 19.5502 19.55 20.0002 19 20.0002ZM17 8.00016H7C6.45 8.00016 6 8.45016 6 9.00016V17.0002C6 17.5502 6.45 18.0002 7 18.0002H17C17.55 18.0002 18 17.5502 18 17.0002V9.00016C18 8.45016 17.55 8.00016 17 8.00016Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_15_606">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 0.000183105)"
        />
      </clipPath>
    </defs>
  </g>
</template>
